import { debounce } from "@mui/material";
import { NumberFormatValues, NumericFormat, NumericFormatProps } from "react-number-format";
import { convertToFloatWithDefaultPrecision } from "src/const/Units";

interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
  value: number;
}

const InputDecimal = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;
    
    const onValueChangeHandler = debounce((values: NumberFormatValues) => {
      onChange({
        target: {
          name: props.name,
          value: values.floatValue,
        },
      });
    }, 20)    

    return (
      <NumericFormat
        decimalScale={3}
        {...other}
        getInputRef={ref}
        decimalSeparator=","
        onValueChange={onValueChangeHandler}
        allowNegative={false}
      />
    );
  },
);

export const InputDecimalToK = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;
    
    const onValueChangeHandler = debounce((values: NumberFormatValues) => {
      onChange({
        target: {
          name: props.name,
          value: values.floatValue,
        },
      });
    }, 20)    

    return (
      <NumericFormat
        decimalScale={3}
        {...other}
        getInputRef={ref}
        decimalSeparator=","
        onValueChange={onValueChangeHandler}
        allowNegative={false}
      />
    );
  },
);

export default InputDecimal
